<template>
    <AuthWrapper>
        <AuthTop
            heading="Welcome back!"
            text="Enter your account details to log in"
        />
        <AuthForm
            :form-data="formData"
            button-label="Log in"
            endpoint="/api/login"
            @callback="login"
        >
            <FormGroup
                label="Email address"
                label-for="email"
            >
                <InputField
                    v-model="formData.email"
                    :required="true"
                    name="email"
                    type="email"
                    autocomplete="email"
                >
                    <template v-slot:icon>
                        <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><path d="M22 6l-10 7L2 6"/></svg>
                    </template>
                </InputField>
            </FormGroup>
            <FormGroup
                label="Password"
                label-for="Password"
            >
                <InputField
                    v-model="formData.password"
                    :required="true"
                    name="password"
                    type="password"
                    autocomplete="current-password"
                >
                    <template v-slot:icon>
                        <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                    </template>
                </InputField>
            </FormGroup>
        </AuthForm>
        <AuthLink
            label="Forgot your password?"
            link="/password/forgot"
        />
    </AuthWrapper>
</template>

<script>
import AuthWrapper from '../../components/auth/AuthWrapper.vue';
import AuthForm from '../../components/auth/AuthForm.vue';
import AuthLink from '../../components/auth/AuthLink.vue';
import AuthTop from '../../components/auth/AuthTop.vue';
import FormGroup from '../../components/form/FormGroup.vue';
import InputField from '../../components/form/InputField.vue';

export default {
    metaInfo: {
        title: 'Login',
    },
    components: {
        AuthWrapper,
        AuthForm,
        AuthLink,
        AuthTop,
        FormGroup,
        InputField,
    },
    data: () => ({
        formData: {
            email: null,
            password: null,
        },
    }),
    methods: {
        async login(data) {
            this.$store.dispatch('auth/saveToken', {
                token: data.token,
                remember: true,
            });
            await this.$store.dispatch('auth/fetchUser');
            this.$toasted.show('You are now logged in');
            this.$router.push({ name: 'home' });
        },
    },
};
</script>
